import * as Noty from 'noty';
/* @ngInject */
export default class NotificationService {
  constructor(private $translate) {
    Noty.overrideDefaults({
      animation: {
        close: 'noty__animation fadeOutDown',
        open: 'noty__animation fadeInUp'
      },
      layout: 'bottomCenter',
      progressBar: false,
      timeout: 5000,
      type: 'success',
      killer: true
    });
  }

  public showNotification(options: Noty.Options) {
    Array.from(document.querySelectorAll('.noty_bar')).forEach((e: HTMLElement) => {
      e.remove();
    });
    return new Noty(options).show();
  }

  public showNoMobilePaymentMessage() {
    this.$translate('pay.mobilepayment.error').then(value => {
      this.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  public showNoAggrementMessage() {
    this.$translate('pay.aggreement.error').then(value => {
      this.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  public createInvoiceError() {
    this.$translate('pay.createInvoice.error').then(value => {
      this.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  public showCreditCardSaveNotSelectedMessage() {
    this.$translate('pay.cardAdd.error').then(value => {
      this.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  public showMessage(message: string) {
    this.showNotification({
      text: message,
      type: 'warning'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/notification/notification.service.ts